import { GeneratableSelectInputOptions } from 'shared-ui/lib/components/customs/form/SelectInput';
import { sharedTranslations } from 'shared-ui/lib/shared-translations';

const allServiceEventTypes = [
  'ALCOLOCK',
  'FRONT_BREAK',
  'AIR_FILTER',
  'TIMING_BELT',
  'GAS_EQUIPMENTS',
  'INSPECTION',
  'SUMMER_TIRE',
  'SPEED_LIMITER',
  'TACHOGRAPH',
  'FUEL_FILTER',
  'EXTINGUISHER',
  'REAR_BREAK',
  'TAXIMETER',
  'WINTER_TIRE',
  'LIGHTS',
  'OIL',
  'PERIODIC_MAINTENANCE',
  'OTHER',
];

const consumerHiddenTypes = ['ALCOLOCK', 'SPEED_LIMITER', 'TACHOGRAPH'];
const fixedOrder: Record<string, number> = {
  PERIODIC_MAINTENANCE: 0,
  OTHER: 1,
};
const fiLabelsByType = (sharedTranslations.fi?.ServiceEventType || {}) as Record<string, string>;

const sortServiceEventTypes = (types: string[]) =>
  [...types].sort((a, b) => {
    const aPriority = fixedOrder[a] ?? Number.MAX_SAFE_INTEGER;
    const bPriority = fixedOrder[b] ?? Number.MAX_SAFE_INTEGER;

    if (aPriority !== bPriority) return aPriority - bPriority;

    const aLabel = fiLabelsByType[a] ?? a;
    const bLabel = fiLabelsByType[b] ?? b;

    return aLabel.localeCompare(bLabel, 'fi');
  });

const mapToOptions = (types: string[]): GeneratableSelectInputOptions['props']['options'] =>
  types.map((value) => ({
    value,
    label: `ServiceEventType:${value}`,
  }));

export const getServiceEventTypeOptionsForConsumerUser =
  (): GeneratableSelectInputOptions['props']['options'] => {
    const visible = allServiceEventTypes.filter((t) => !consumerHiddenTypes.includes(t));
    return mapToOptions(sortServiceEventTypes(visible));
  };

export const getServiceEventTypeOptions =
  (): GeneratableSelectInputOptions['props']['options'] =>
    mapToOptions(sortServiceEventTypes(allServiceEventTypes));
